import React, {useCallback} from 'react'
import {Redirect} from 'react-router-dom'
import {useEvent} from 'Event/EventProvider'
import {eventRoutes} from 'Event/Routes'
import {client} from 'lib/ui/api-client'
import {api, useQueryParams} from 'lib/url'
import {EmojiDisplay, Emojis} from 'organization/Event/EmojiPage'

export default function TokenEmojiPage() {
  const {event} = useEvent()
  const {token} = useQueryParams()

  const fetchEmojis = useCallback(
    () =>
      client.get<Emojis>(api(`/events/${event.id}/emoji_page?token=${token}`)),
    [event.id, token],
  )

  if (!token) {
    return <Redirect to={eventRoutes.login} />
  }

  return <EmojiDisplay fetchEmojis={fetchEmojis} />
}
